import { useMemo } from "react";

import { getDateTitle } from "utils/dateUtils";

import RadioChip from "./RadioChip";

const DateChip = ({
  value,
  date,
  onSelected,
  selected = false,
  disabled = false,
  "data-testid": dataTestId,
}: {
  value: number;
  date: Date;
  selected?: boolean;
  onSelected: (arg: number) => void;
  disabled?: boolean;
  "data-testid"?: string;
}) => {
  const { title, month, day } = useMemo(() => getDateTitle(date), [date]);
  const subTitle = disabled ? "Closed" : `${month} ${day}`;
  const onChange = () => onSelected(value);

  return (
    <RadioChip
      value={value}
      selected={selected}
      onChange={onChange}
      disabled={disabled}
      className="w-full min-w-[6.5rem] flex-grow"
      data-testid={dataTestId}
    >
      <span className="font-bold">{title}</span>{" "}
      <span className="text-xs whitespace-nowrap">{subTitle}</span>
    </RadioChip>
  );
};

export default DateChip;
